import { render, staticRenderFns } from "./Penjualan.vue?vue&type=template&id=3251a4df&scoped=true&"
import script from "./Penjualan.vue?vue&type=script&lang=js&"
export * from "./Penjualan.vue?vue&type=script&lang=js&"
import style0 from "./Penjualan.vue?vue&type=style&index=0&id=3251a4df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3251a4df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VChip,VIcon,VSheet,VSpacer,VSwitch,VTab,VTabItem,VTabs})
